var angular = require('angular')

angular.module('AemCspsDisbursementCalculator')
  .factory('appDataservice', appDataservice)

appDataservice.$inject = ['wgService', 'widgetParamsService']

function appDataservice (wgService, widgetParamsService) {
  var self = {
    paramsPromise: paramsPromise(),
    error: null
  }

  function paramsPromise () {
    return widgetParamsService.get(wgService.getAppName())
      .then(function (res) {
        return res
      })
      .catch(function (err) {
        self.error = err
      })
  }

  return self
}
